import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../../../../../component';
import nls from '../../nls/pt-BR.json';
import {
  LaunchedUnitsECO,
  LaunchedUnitsECOMAP,
  LaunchedUnitsMAP,
} from './launchedUnits';
import {
  LaunchedUnitsSalesECO,
  LaunchedUnitsSalesECOMAP,
  LaunchedUnitsSalesMAP,
} from './launchedUnitsSales';
import { PercentileOffersECOMAP } from './percentileOffers';
import { PercentileVGVECOMAP } from './percentileVGV';
import {
  ReleasesSalesStockECO,
  ReleasesSalesStockECOMAP,
  ReleasesSalesStockMAP,
} from './releasesSalesStock';
import { SalesECO, SalesECOMAP, SalesMAP } from './sales';
import {
  WeightedAverageECO,
  WeightedAverageECOMAP,
  WeightedAverageMAP,
} from './weightedAverage';
import './primaryCharts.scss';
import {
  setDisplayGeneralCharts,
  setPDFImages,
} from '../../redux/offersPrimary.actions';
import * as htmlToImage from 'html-to-image';
import { useTypedSelector } from '../../../../../hooks/useTypedSelector';
import { modalOpen } from '../../../redux/dashboardActions';

const getPDF = () => (dispatch: any) => {
  const firstChart = document.getElementsByClassName(
    'chart-card--full-container--component-container'
  )[0] as HTMLElement;
  const secondChart = document.getElementsByClassName(
    'chart-card--full-container--component-container'
  )[1] as HTMLElement;
  const elements = [firstChart, secondChart];
  const promises = elements.map((elem) => htmlToImage.toPng(elem));
  Promise.all(promises)
    .then((res) => {
      dispatch([setPDFImages(res), modalOpen('render pdf preview')]);
    })
    .catch((err) => console.error(err));
};

const UnmemoizedPrimaryChartsEcoMap: React.FC = () => {
  const { displayGeneralCharts } = useSelector(
    (state: any) => state.offersPrimaryState
  );
  const dispatch = useDispatch();
  const MemoizedGeneralCharts = memo(GeneralCharts);
  const MemoizedChartsByConstructionPattern = memo(ChartsByConstructionPattern);
  const { statusModal } = useTypedSelector((state) => state.dashboardState);
  return (
    <div className="primary-charts-eco-map">
      <div className="charts-page--navigation-menu">
        <Button
          cy="NavigationGeneral"
          className={`btn secondary ${
            displayGeneralCharts ? 'active' : 'inactive'
          }`}
          onClick={() => dispatch(setDisplayGeneralCharts(true))}
        >
          {nls.primaryChartsEcoMap.general}
        </Button>

        <Button
          cy="NavigationConstrPattern"
          className={`btn secondary ${
            displayGeneralCharts ? 'inactive' : 'active'
          }`}
          onClick={() => dispatch(setDisplayGeneralCharts(false))}
        >
          {nls.primaryChartsEcoMap.byConstructionPattern}
        </Button>
        <Button cy="Test" onClick={() => dispatch(getPDF())}>
          PDF
        </Button>
      </div>
      <div className="primary-charts__content-container">
        <div
          className={`primary-charts-container ${
            displayGeneralCharts ? 'selected' : ''
          }`}
        >
          <MemoizedGeneralCharts />
        </div>
        <div
          className={`primary-charts-container ${
            displayGeneralCharts ? '' : 'selected'
          }`}
        >
          <MemoizedChartsByConstructionPattern />
        </div>
      </div>
      {/* {statusModal === 'render pdf preview' && <RenderPDFReport />} */}
    </div>
  );
};

const GeneralCharts: React.FC = () => {
  const { isGridView } = useSelector((state: any) => state.chartsState);
  return (
    <div className={`general-charts ${!isGridView && 'list-layout'}`}>
      <LaunchedUnitsECOMAP />
      <LaunchedUnitsSalesECOMAP />
      <PercentileOffersECOMAP />
      <PercentileVGVECOMAP />
      <SalesECOMAP />
      <ReleasesSalesStockECOMAP />
      <WeightedAverageECOMAP />
    </div>
  );
};

const ChartsByConstructionPattern: React.FC = () => {
  const { isGridView } = useSelector((state: any) => state.chartsState);

  return (
    <div
      className={`charts-by-construction-pattern ${
        !isGridView && 'list-layout'
      }`}
    >
      <LaunchedUnitsECO />
      <LaunchedUnitsMAP />
      <LaunchedUnitsSalesECO />
      <LaunchedUnitsSalesMAP />
      <SalesECO />
      <SalesMAP />
      <ReleasesSalesStockECO />
      <ReleasesSalesStockMAP />
      <WeightedAverageECO />
      <WeightedAverageMAP />
    </div>
  );
};

const PrimaryChartsEcoMap = memo(UnmemoizedPrimaryChartsEcoMap);
export { PrimaryChartsEcoMap };
